const PRODUCTION_HOSTS = new Set(['dad-partners.com', 'www.dad-partners.com', 'admin.dad-partners.com']);

// Where the member site lives, relative to wherever this admin app is running.
export const getMemberSiteUrl = (location = typeof window === 'undefined' ? null : window.location) => {
  if (!location) return 'https://www.dad-partners.com';
  const { hostname, protocol } = location;
  const isLocalDevHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    (protocol === 'http:' && !PRODUCTION_HOSTS.has(hostname));
  return isLocalDevHost ? `${protocol}//${hostname}:3000` : 'https://www.dad-partners.com';
};
